import React, { useEffect, useState } from 'react'
import DynamicPageBanner from './DynamicPageBanner'
import DynamicPageOverview from './DynamicPageOverview'
import DynamicPageDesign from './DynamicPageDesign'
import DynamicPageSmart from './DynamicPageSmart'
import DynamicPageAi from './DyanamicPageAi'
import DynamicPageFaqs from './DynamicPageFaqs'
import { useNavigate, useParams } from 'react-router-dom'
import { BaseUrl } from '../../helper/BaseUrl'
import DynamicPageCounter from './DynamicPageCounter'
import DynamicPageAdopt from './DynamicPageAdopt'

export default function DynamicPage({ initialData }) {
  const { dynamicpage_slug } = useParams();
  const [AllData, setAllData] = useState(initialData || {});
  const navigate = useNavigate();
  useEffect(() => {
    const aifetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}api/dynamicpage/view/${dynamicpage_slug}`, {
          method: 'GET',
        });
        const result = await response.json();
        if (!result.data) {
          navigate("/404", { replace: true });
          return;
        }
        setAllData(result.data);
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    // aifetcher();
    if (!initialData || Object.keys(initialData).length === 0) {
      aifetcher();
    }
  }, [dynamicpage_slug, navigate]);

  const countData = {
    title: "Streamlined Control, Reduced Overhead",
    para: "Simplify governance with faster, secure data operations.",
    btn: "Transform Your Data Operations",
  }

  const adoptData = {
    firstimg: "/assets/images/physical-adopt-blur.webp",
    secondimg: "/assets/images/physical-adopt-img1.webp",
  }

  const securityData = {
    head: "AI-Driven Document Management Solutions.",
    boxes: [
      {
        img: "/assets/images/final-data-integration-img-1.webp",
        label: "Physical Records & Archive Management",
        slug: "/physical-records-management-services"
      },
      {
        img: "/assets/images/final-data-integration-img-2.webp",
        label: "Intelligent Document Processing & AI-driven Extraction",
        slug: '/ai-document-data-extraction'
      },
      {
        img: "/assets/images/final-data-integration-img-3.webp",
        label: "Scanning & Digitization Services",
        slug: '/digitization-services'
      },
      {
        img: "/assets/images/final-data-integration-img-4.webp",
        label: "Data Governance & Compliance Platform (SaaS)",
        slug: "/data-privacy-governance-compliance-platform"
      },

    ]
  }

  return (
    <>
      <DynamicPageBanner data={AllData} />
      <DynamicPageOverview data={AllData} />
      <DynamicPageDesign data={AllData} />
      <div className="ai-extraction-tool"> <DynamicPageCounter countData={countData} data={AllData} /> </div>
      <DynamicPageSmart data={AllData} />
      <DynamicPageAdopt adoptdata={adoptData} data={AllData} />
      <div className="ai-extraction-tool"> <DynamicPageAi data={securityData} /> </div>
      <DynamicPageFaqs data={AllData} />
    </>
  )
}
